import * as yup from 'yup';

export const resetValidatorSchema = yup.object().shape({
    newPassword: yup.string().matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,'Password must be eight characters including one uppercase letter, one special character and alphanumeric characters( Ex: Ps#12354 )').required('Password is required'),
    confirmpassword: yup.string().required('Confirm password is required').oneOf([yup.ref('newPassword'),null],'Password and confirm password should be same'),
});
